import { render } from "./CrownGradientIcon.vue?vue&type=template&id=9c2e8660"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__